<template>
    <vs-popup class="create-marketing-lead-popup" id="popup" :title="isCreateMode ? 'CREATE NEW ENQUIRY' : 'UPDATE A LEAD'"
        @close="open = false" :active.sync="open" :buttons-hidden="true">
        <vx-card no-shadow>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form id="create-marketing-lead-popup" @submit.prevent="handleSubmit(onClickCreateLead)" autocomplete="off">

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                                <small class="label">Status</small>
                                <v-select :clearable="false" placeholder="" v-model="form.status" :options="status_list"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="form.status === 'Opportunity'" label="name"
                                    :reduce="option => option.value">
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0" v-if="isCreateMode">
                            <ValidationProvider vid="mailchimp" name="mailchimp" rules="" v-slot="{ errors }">
                                <small class="label">Status (mailchimp)</small>
                                <v-select :clearable="false" placeholder="" v-model="form.mailchimp_status"
                                    :options="['pending', 'subscribed', 'unsubscribed', 'cleaned', 'transactional']"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" :disabled="!isCreateMode">
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0" v-if="!isCreateMode">
                            <ValidationProvider vid="mailchimp_member_id" name="mailchimp_member_id" rules=""
                                v-slot="{ errors }">
                                <small class="label text-primary">Mailchimp Member ID</small>
                                <vs-input disabled v-model="form.mailchimp_member_id" name="mailchimp_member_id"
                                    class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                    val-icon-danger="icon-x" val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                                <small class="label">First Name</small>
                                <vs-input v-model="form.first_name" name="first_name" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                                <small class="label">Last Name</small>
                                <vs-input v-model="form.last_name" name="last_name" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="email_address" name="email_address" rules="required|email"
                                v-slot="{ errors }">
                                <small class="label">Email Address</small>
                                <vs-input v-model="form.email" name="email_address" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="company_name" name="company_name" rules="required" v-slot="{ errors }">
                                <small class="label">Company Name</small>
                                <vs-input v-model="form.company_name" name="company_name" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    @input="onInputCompanyName" val-icon-pack="feather" />
                            </ValidationProvider>
                            <small class="text-danger" v-if="existing_company_list.length > 0">
                                This company name is already in use. Please choose a different name.
                            </small>
                        </div>
                    </div>

                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="industry_sector" name="industry_sector" rules="required"
                                v-slot="{ errors }">
                                <small class="label">Industry Sector</small>
                                <v-select multiple v-on:input="onChangeIndustrySector" :clearable="false"
                                    :closeOnSelect="false" name="industry_sector" placeholder="" label="name"
                                    v-model="form.sector" :reduce="option => option.id" :options="industrySectors"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                </v-select>

                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="industry_sub_sector" name="industry_sub_sector" rules=""
                                v-slot="{ errors }">
                                <small class="label">Industry Sub Sector</small>
                                <v-select multiple :clearable="false" :closeOnSelect="false" name="industry_sub_sector"
                                    placeholder="" label="name" v-model="form.sub_sector" :reduce="option => option.id"
                                    :options="industrySubSectors" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        Please select Industry Sector first!
                                    </template>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="source" name="source" rules="required" v-slot="{ errors }">
                                <small class="label">Source</small>
                                <v-select multiple v-on:input="onChangeCustomerSource" :clearable="false"
                                    :closeOnSelect="false" name="industry_sector" placeholder="" label="name"
                                    v-model="form.source" :reduce="option => option.id" :options="customerSources"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                </v-select>

                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="sub_source" name="sub_source" rules="required" v-slot="{ errors }">
                                <small class="label">Sub Source</small>
                                <v-select multiple :clearable="false" :closeOnSelect="false" name="sub_source"
                                    placeholder="" label="name" v-model="form.sub_source" :reduce="option => option.id"
                                    :options="customerSubSources" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.name }} </span>
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        Please select Industry Sector first!
                                    </template>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row mb-3">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="account_handler_id" name="account_handler_id" rules=""
                                v-slot="{ errors }">
                                <small class="label">Account Handler</small>
                                <v-select :clearable="false" name="account_handler_id" placeholder="" label="name"
                                    :reduce="option => option.value" v-model="form.account_handler_id" :options="account_handlers"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="country" name="country" rules="" v-slot="{ errors }">
                                <small class="label">Country</small>
                                <v-select :clearable="false" name="country" placeholder="" label="name"
                                    :reduce="option => option.name" v-model="form.country" :options="countries"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0 mb-2 pt-1" v-for="(field, index) in merge_fields"
                            :key="index" v-if="!field.is_hidden">
                            <ValidationProvider :vid="field.name" :name="field.name"
                                :rules="field.is_required ? 'required' : ''" v-slot="{ errors }"
                                v-if="field.type === 'text'" class="mb-4">
                                <small class="label">{{ field.name }}</small>
                                <vs-input v-model="field.value" :name="field.name" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                            <ValidationProvider :vid="field.name" :name="field.name"
                                :rules="field.is_required ? 'required' : ''" v-slot="{ errors }"
                                v-if="field.type === 'dropdown'">
                                <small class="label">{{ field.name }}</small>
                                <v-select :clearable="false" placeholder="" v-model="field.value"
                                    :options="field.data.dropdown" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="follow_up_date" name="follow_up_date" rules="" v-slot="{ errors }">
                                <small class="label">Follow Up Date</small>
                                <flat-pickr :config="{ enableTime: false, dateFormat: 'd/m/Y' }" class="hidden"
                                    v-model="form.follow_up_date" placeholder="Choose Date" />
                                <flat-pickr :config="{ enableTime: false, dateFormat: 'd/m/Y' }" class="w-full"
                                    v-model="form.follow_up_date" placeholder="Choose Date" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="enquiry" name="enquiry" rules="" v-slot="{ errors }">
                                <small class="label">Initial Enquiry</small>
                                <vs-textarea class="mb-0" v-model="form.enquiry" height="100px" />
                                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col">
                            <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                                <small class="label">Notes</small>
                                <vs-textarea class="mb-0" v-model="form.notes" height="150px" />
                                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <!-- Save & Reset Button -->
                    <div class="flex flex-wrap items-center justify-end mt-8">
                        <vs-button button="submit" class="mt-2 ml-auto">Save
                            Changes</vs-button>
                        <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
                    </div>
                </form>
            </ValidationObserver>
        </vx-card>
        <CheckLeadCompanyNamePopUp ref="checkLeadCompanyNamePopUp" @useCompanyName="useCompanyName"/>
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CrmRepository = RepositoryFactory.get('crm');
const CustomerRepository = RepositoryFactory.get('customer');
const CustomerSourceRepository = RepositoryFactory.get('customer_source')

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { mapActions, mapGetters } from 'vuex';

import CheckLeadCompanyNamePopUp from './CheckLeadCompanyNamePopUp.vue';

function initialState() {
    return {
        open: false,
        id: '',
        merge_fields: [],
        form: {
            company_name: ''
        },
        isCreateMode: true,
        industrySectors: [],
        industrySubSectors: [],
        customerSources: [],
        customerSubSources: [],
        status_list: [
            { name: 'New Enquiry', value: 'Pending' },
            { name: 'Lead', value: 'Lead' },
            { name: 'Subscriber', value: 'Subscriber' },
            { name: 'Junk', value: 'Junk' }
        ],
        existing_company_list: []
    }
}

export default {
    name: 'CreateMarketingLeadPopUp',
    data() {
        return initialState()
    },
    methods: {
        ...mapActions(['fetchCountries', 'fetchAccountHandlers']),
        async openPopup(id) {
            try {
                await Object.assign(this.$data, initialState());
                await this.$refs.form.reset();
                this.open = true;
                await this.fetchMergeFields();
                await this.loadIndustrySectors();
                await this.loadCustomerSources();
                await this.fetchCountries()
                await this.fetchAccountHandlers()
                if (!!id) {
                    this.id = id
                    this.isCreateMode = false
                    await this.fetchIncotermDetails()
                    await this.increaseLeadOpenCount()
                } else {
                    this.$refs.checkLeadCompanyNamePopUp.openPopup()
                    this.isCreateMode = true
                }
            } catch (error) {

            }
        },
        async fetchIncotermDetails() {
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                const { data } = (await CrmRepository.getMerketingLeadDetails(this.id)).data
                this.form = data
                this.merge_fields = this.merge_fields.map((x) => {
                    const find = this.form.merge_fields.find((y) => y.tag === x.tag)
                    x.value = find ? find.value : (find.default_value ? find.default_value : '')
                    return x
                })
                if (this.form.sub_sector.length !== 0) {
                    const { data } = (await CustomerRepository.getIndustrySubSectors({ ids: this.form.sector })).data
                    this.industrySubSectors = data
                }
                if (this.form.sub_source.length !== 0) {
                    const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: this.form.source })).data
                    this.customerSubSources = data
                }
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async increaseLeadOpenCount() {
            try {
                await CrmRepository.increaseLeadOpenCount(this.id)
            } catch (error) {

            }
        },
        async loadIndustrySectors() {
            const { data } = (await CustomerRepository.getIndustrySectors()).data
            this.industrySectors = data
        },
        async onChangeIndustrySector(ids) {
            await this.$vs.loading();
            try {
                this.form.sub_sector = []
                const { data } = (await CustomerRepository.getIndustrySubSectors({ ids: ids })).data
                this.industrySubSectors = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            await this.$vs.loading.close()
        },
        async loadCustomerSources() {
            const { data } = (await CustomerSourceRepository.getListOfCustomerSource()).data
            this.customerSources = data
        },
        async onChangeCustomerSource(ids) {
            await this.$vs.loading();
            try {
                this.form.sub_source = []
                const { data } = (await CustomerSourceRepository.getCustomerSubSources({ ids: ids })).data
                this.customerSubSources = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            await this.$vs.loading.close()
        },
        async fetchMergeFields() {
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                const { data } = (await CrmRepository.getCrmMergedFields())
                this.merge_fields = data.data.filter((x) => !x.is_hidden).map((x) => { x.value = x.default_value ? x.default_value : ''; return x; })
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async onClickCreateLead() {
            const vue = this;
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                if (this.isCreateMode) {
                    let payload = {}
                    Object.assign(payload, this.form)
                    payload.merge_fields = this.merge_fields.map((x) => ({ tag: x.tag, value: x.value }))
                    await CrmRepository.createMarketingLead(payload);
                    this.showSuccessMessage('Lead created successfully');
                } else {
                    let payload = {}
                    Object.assign(payload, this.form)
                    payload.merge_fields = this.merge_fields.map((x) => ({ tag: x.tag, value: x.value }))
                    if (payload.status === 'Opportunity') delete payload.status
                    await CrmRepository.updateMerketingLead(this.id, payload);
                    this.showSuccessMessage('Lead updated successfully!');
                }
                await vue.$parent.refreshData();
                this.open = false;
            } catch (e) {
                this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async onInputCompanyName() {
            await this.searchComapnyName(this)
        },
        searchComapnyName: _.debounce(async (vm) => {
            const { data } = (await CrmRepository.getListOfMarketingLeads(1, `filter[search]=${vm.form.company_name}`, 150, '')).data
            vm.existing_company_list = data.filter((x) => {
                const companyName = x.company_name ? x.company_name.toLowerCase() : null;
                const formCompanyName = vm.form.company_name ? vm.form.company_name.toLowerCase() : null;
                return companyName === formCompanyName && !!companyName;
            }).map((x) => x.company_name)
        }, 350),
        useCompanyName(company_name) {
            this.form.company_name = company_name
        }
    },
    components: {
        flatPickr,
        'v-select': vSelect,
        CheckLeadCompanyNamePopUp
    },
    computed: {
        ...mapGetters(['countries', 'account_handlers'])
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.create-marketing-lead-popup>>>.vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
}
</style>
  